import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import {
  hidePptFlyout,
  selectWizardStep,
  setWizardStep,
} from '../../store/slices/export-ppt.slice';
import { WidgetModel } from '../../models/widget.model';

import * as InsightsDetailComposition from '../../../modules/insights/data/insight-detail.config.json';
import AlignmentDetailComposition from '../../../modules/insights/data/page-configs/alignment-detail.config';

import ChooseType from './PowerpointExport/ChooseType';
import WizardSummary from './PowerpointExport/WizardSummary';
import Question from './PowerpointExport/Question';
import { ALIGNMENT_ROUTES, INSIGHTS_ROUTES } from 'routes/routes.const';
import { WizardStep } from '../../models/pptx.model';

export interface WizardStepProps {
  onClose: () => void;
}
export default function PowerpointExportWizardFlyout() {
  const wizardStep = useAppSelector(selectWizardStep);
  const dispatch = useAppDispatch();
  const closePptExport = () => {
    dispatch(setWizardStep(WizardStep.PowerpointExportChooseOption));
    dispatch(hidePptFlyout());
  };

  if (wizardStep === WizardStep.PowerpointExportSummary) {
    return <WizardSummary onClose={closePptExport} />;
  }
  if (wizardStep == WizardStep.PowerpointExportQuestion) {
    return <Question onClose={closePptExport} />;
  }
  return <ChooseType onClose={closePptExport} />;
}

export const paginatedExportPages = [`${ALIGNMENT_ROUTES.summary}`, `${INSIGHTS_ROUTES.summary}`];

export const getChartJson = (chartId: string, isAlignment: boolean): WidgetModel => {
  const targetComposition = isAlignment ? AlignmentDetailComposition : InsightsDetailComposition;
  const widgetJson = targetComposition.widgets.filter((widget) => widget.id === chartId);
  return widgetJson[0] as unknown as WidgetModel;
};

export const getPageTitle = (isAlignment: boolean): string => {
  const targetComposition = isAlignment ? AlignmentDetailComposition : InsightsDetailComposition;
  return targetComposition.pageTitle;
};
